<template>
    <section id="termos">
      <h2>Termos de Uso</h2>

      <p><strong>Última atualização:</strong> 16 de maio de 2026</p>

      <p>
        Ao utilizar o LineApps, o usuário concorda com estes Termos de Uso.
      </p>

      <h3>1. Objeto</h3>

      <p>
        O LineApps é uma plataforma digital destinada à:
      </p>

      <ul>
        <li>Análise de balancetes;</li>
        <li>Processamento de informações contábeis;</li>
        <li>Geração de indicadores financeiros;</li>
        <li>Apoio à organização e análise de dados empresariais.</li>
      </ul>

      <h3>2. Cadastro e Acesso</h3>

      <p>
        Para utilizar determinadas funcionalidades,
        o usuário deverá:
      </p>

      <ul>
        <li>Realizar cadastro;</li>
        <li>Fornecer informações verdadeiras;</li>
        <li>Manter suas credenciais seguras.</li>
      </ul>

      <h3>3. Uso da Plataforma</h3>

      <p>
        O usuário concorda em:
      </p>

      <ul>
        <li>Utilizar a plataforma de forma lícita;</li>
        <li>Não enviar arquivos maliciosos;</li>
        <li>Não tentar obter acesso indevido;</li>
        <li>Não comprometer a segurança do sistema.</li>
      </ul>

      <h3>4. Arquivos Enviados</h3>

      <p>
        O usuário poderá enviar balancetes e arquivos financeiros para processamento.
      </p>

      <p>
        O usuário declara possuir legitimidade para utilização e envio das informações processadas.
      </p>

      <p>
        O LineApps poderá realizar:
      </p>

      <ul>
        <li>leitura automatizada dos arquivos enviados;</li>
        <li>estruturação de dados contábeis;</li>
        <li>processamento automatizado de informações financeiras;</li>
        <li>anonimização parcial de descrições de contas analíticas.</li>
      </ul>

      <div class="highlight">
        Os arquivos enviados serão removidos automaticamente após o processamento.
      </div>

      <h3>5. Disponibilidade do Serviço</h3>

      <p>
        O LineApps busca manter a plataforma disponível continuamente,
        mas não garante funcionamento ininterrupto ou livre de falhas.
      </p>

      <h3>6. Limitação de Responsabilidade</h3>

      <p>
        O LineApps atua como ferramenta de apoio à análise financeira e contábil.
      </p>

      <p>
        O usuário permanece responsável pela validação das informações,
        conferência dos resultados e decisões empresariais tomadas com base na plataforma.
      </p>

      <h3>7. Segurança</h3>

      <p>
        O LineApps adota medidas razoáveis de segurança para proteção das informações processadas.
      </p>

      <h3>8. Propriedade Intelectual</h3>

      <p>
        A plataforma, incluindo software, interface, funcionalidades,
        identidade visual e conteúdos próprios pertence ao LineApps.
      </p>

      <h3>9. Suspensão e Encerramento</h3>

      <p>
        O LineApps poderá suspender ou encerrar contas que violem estes Termos
        ou comprometam a segurança da plataforma.
      </p>

      <h3>10. Alterações dos Termos</h3>

      <p>
        Estes Termos poderão ser atualizados periodicamente.
      </p>

      <h3>11. Contato</h3>

      <p>
        E-mail: lineapps@pgpaf.com.br
      </p>
    </section>
</template>

<script>
export default {
  name: "TermosDeUso",

  methods: {},

  mounted() {},

  created() {},
};

</script>

<style scoped src="@/assets/css/legal.css">
</style>
